import { render, staticRenderFns } from "./IOTDataATG.vue?vue&type=template&id=72e0208d"
import script from "./IOTDataATG.vue?vue&type=script&lang=js"
export * from "./IOTDataATG.vue?vue&type=script&lang=js"
import style0 from "./IOTDataATG.vue?vue&type=style&index=0&id=72e0208d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports